export default {
  title: 'Päivitä {{name}} profiili',
  form: {
    name: {
      label: 'Nimi',
      placeholder: 'Anna omistajan koko nimi',
    },
    email: {
      label: 'Sähköposti',
      placeholder: 'Anna omistajan henkilökohtainen sähköposti',
      tooltip:
        'Ravintolan omistajan/esihenkilön henkilökohtainen sähköposti. Käytetään hallintapaneeliin kirjautumiseen',
    },
  },
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    failed_to_save_changes: 'Muutosten tallennus epäonnistui',
    changes_got_saved: 'Muutokset tallennettiin',
  },
};
